/**
 * Named handles onto the generated tokens. The ported markup sets styles inline
 * (that is how the design ships), so it needs the values in JS — but no file in
 * src/ ever types a hex: everything below resolves through tokens.ts.
 */
import { tokens } from '../styles/tokens.ts';

export const PAPER = tokens['color-paper'];
export const INK = tokens['color-ink'];
export const MUTED = tokens['color-muted'];
export const CREAM = tokens['color-cream'];
export const SAND = tokens['color-sand'];
export const LINE = tokens['color-line'];
export const CORAL = tokens['color-coral'];
export const ORANGE = tokens['color-orange'];
export const YELLOW = tokens['color-yellow'];
export const VIOLET = tokens['color-violet'];
export const CORAL_DEEP = tokens['color-coral-deep'];
export const LAVENDER = tokens['color-lavender-soft'];

/** gradients */
export const GRAD = `linear-gradient(135deg,${CORAL},${ORANGE})`;
export const CEL = `linear-gradient(135deg,${VIOLET},${CORAL})`;
export const SUN = `linear-gradient(135deg,${YELLOW},${ORANGE})`;
export const TEXT_GRAD = `linear-gradient(135deg,${ORANGE},${CORAL})`;
export const SURFACE_SOFT = `linear-gradient(135deg,${CREAM},${SAND})`;
export const PROGRESS_FILL = tokens['funnel-progress-fill'];
export const TIMER_BG = tokens['funnel-timer-card-bg'];
export const TIMER_FILL = tokens['funnel-timer-card-fill'];
export const IG_GRADIENT = tokens['funnel-ig-gradient'];

/** green "fit"/result surfaces */
export const GREEN_BG = tokens['funnel-green-bg'];
export const GREEN_FG = tokens['funnel-green-fg'];
export const GREEN_TEXT = tokens['funnel-green-text'];
export const BRAND_RED = tokens['funnel-brand-red'];

/** shadows */
export const SHADOW_CARD = tokens['shadow-card'];
export const SHADOW_RAISED = tokens['shadow-card-raised'];
export const SHADOW_FLOAT = tokens['shadow-float'];
export const SHADOW_GLOW = tokens['shadow-primary-glow'];
export const SHADOW_GLOW_STRONG = tokens['shadow-primary-glow-strong'];

/** motion, in ms */
export const MOTION = {
  screenIn: 300,
  fast: 200,
  pop: 500,
  confetti: 1100,
  scan: 2200,
  autoAdvance: 250,
  swipeFly: 420,
  hold: 600,
  chartFill: 1600,
  chartDraw: 3400,
} as const;

export const CONFETTI_COLORS = [YELLOW, ORANGE, PAPER, CORAL, LAVENDER];

/** brand marks (third-party palettes live in tokens.color.brandMarks) */
export const MARKS = {
  visa: tokens['color-brand-marks-visa'],
  mastercardRed: tokens['color-brand-marks-mastercard-red'],
  mastercardOrange: tokens['color-brand-marks-mastercard-orange'],
  paypalNavy: tokens['color-brand-marks-paypal-navy'],
  paypalBlue: tokens['color-brand-marks-paypal-blue'],
  googleBlue: tokens['color-brand-marks-google-blue'],
  applePay: tokens['color-brand-marks-apple-pay-pill'],
};
